import {
  Box,
  Tooltip,
  TooltipProps,
  tooltipClasses,
  styled
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        margin: 0 auto;
        font-weight: ${theme.typography.fontWeightBold};
        width: 100%;
        justify-content: center;
`
);

const LogoImageWrapper = styled(Box)(
  ({ theme }) => `
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        margin: 0 auto;
        width: fit-content;
        img {
          width: 100%;
          height: auto;
          max-width: 112px;
        }
`
);

const TooltipWrapper = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100]
  }
}));

function Logo() {
  const { t } = useTranslation();
  const logoUrl = '/static/images/logo/logo.png';

  return (
    <TooltipWrapper title={t('logoSign.tooltip')} arrow>
      <LogoWrapper to="/dashboards/main">
        <LogoImageWrapper>
          <img src={logoUrl} alt={t('logoSign.alt')} />
        </LogoImageWrapper>
      </LogoWrapper>
    </TooltipWrapper>
  );
}

export default Logo;
